import { DEFAULT_MOB_NO_REGEX, LOCAL_STORAGE_KEYS } from "../constants";
import { getLocalStorageItem } from "./storageHelper";
export var REG = {
    emailId: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    mobileNumber: /^\d{10}$/,
    documentNumber: /^[a-z0-9]+$/i,
    panNumber: /([A-Z]){5}([0-9]){4}([A-Z]){1}$/,
    adharNumber: /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/,
    voterId: /^([a-zA-Z]){3}([0-9]){7}?$/,
    validString: /^[a-zA-Z]*$/,
    nonNumericNumber: /[^0-9]/g,
    mobileNumberWithoutHyphone: /\D[^\.]/g,
    validateDecimalUptoTwoDigit: /^(\d*\.{0,1}\d{0,2}$)/,
    validateDecimalAndNonNumeric: /^\d+(\.\d{0,2})?$/,
    validateDecimalUptoOneDigit: /^\d+(\.\d{0,1})?$/,
    validateInteger: /^\d+$/,
    DocumnetNumber: /^[a-zA-Z0-9-]+$/
    ///^[a-zA-Z0-9-]+$/;
};
var MobileNoRegex = getLocalStorageItem(LOCAL_STORAGE_KEYS.MOBILE_NO_REGEX);
export var isValidEmail = function (value) {
    if (value.match(REG.emailId))
        return true;
    else
        return false;
};
export var isValidDocNumber = function (input) {
    var _REG$DocumnetNumber;
    return REG === null || REG === void 0 || (_REG$DocumnetNumber = REG.DocumnetNumber) === null || _REG$DocumnetNumber === void 0 ? void 0 : _REG$DocumnetNumber.test(input);
};
export var isValidMobileNumber = function (value) {
    if (value.match(REG.mobileNumber))
        return true;
    else
        return false;
};
export var isValidDocumentNumber = function (value) {
    if (!value)
        return true;
    if (value.match(REG.documentNumber))
        return true;
    else
        return false;
};
export var isValidPAN = function (value) {
    if (value.match(REG.panNumber))
        return true;
    else
        return false;
};
export var isValidAdhar = function (value) {
    if (value.match(REG.adharNumber))
        return true;
    else
        return false;
};
export var isValidVoterId = function (value) {
    if (value.match(REG.voterId))
        return true;
    else
        return false;
};
export var isValidString = function (value) {
    if (value.match(REG.validString))
        return true;
    else
        return false;
};
export var formateAdhar = function (value) {
    var updatedValue = value.replaceAll(' ', '');
    var newValue = '';
    for (var i = 0; i < updatedValue.length; i++) {
        if (i == 3 || i == 7)
            newValue += updatedValue.charAt(i) + ' ';
        else
            newValue += updatedValue.charAt(i);
    }
    return newValue;
};
export var isNullOrEmpty = function (value) {
    if (value === null || value === '' || value === undefined)
        return true;
    else
        return false;
};
export var isMobileNoTenDigit = function (value) {
    value = value.replace(REG.nonNumericNumber, '');
    // Limit the number of characters to 10
    value = value.slice(0, 10);
    return value;
};
export var validateEmail = function (inputText) {
    var mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (inputText.match(mailFormat)) {
        return true;
    }
    else {
        return false;
    }
};
export var validateContactNumber = function (inputText, len) {
    if (len == 8) {
        var phoneNo = /^\d{8}/;
        if (inputText.match(phoneNo) && inputText.length <= len) {
            return false;
        }
        else {
            return true;
        }
    }
    if (len == 9) {
        var phoneNo = /^\d{9}/;
        if (inputText.match(phoneNo) && inputText.length == len) {
            return false;
        }
        else {
            return true;
        }
    }
    if (len == 10) {
        var phoneNo_1 = MobileNoRegex ? MobileNoRegex : DEFAULT_MOB_NO_REGEX;
        phoneNo_1 = new RegExp(phoneNo_1);
        if (inputText.match(phoneNo_1) && inputText.length == len) {
            return false;
        }
        else {
            return true;
        }
    }
    if (len == 11) {
        var phoneNo = /^\d{11}/;
        if (inputText.match(phoneNo) && inputText.length == len) {
            return false;
        }
        else {
            return true;
        }
    }
    if (len == 12) {
        var phoneNo = /^\d{12}/;
        if (inputText.match(phoneNo) && inputText.length == len) {
            return false;
        }
        else {
            return true;
        }
    }
};
export var isEmptyArray = function (array) {
    if (array.length === 0) {
        return true;
    }
    else {
        return false;
    }
};
